var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 265,
    height: 80,
    fill: "none",
    viewBox: "0 0 265 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2BB7",
    fillRule: "evenodd",
    d: "M92.697 63.096a.679.679 0 0 0 .22-.48l-.087-16.957h8.645c9.013 0 14.524-5.761 14.459-13.945-.064-8.183-5.446-13.88-14.459-13.88h-15.82a.624.624 0 0 0-.492.207.637.637 0 0 0-.157.514v44.06a.679.679 0 0 0 .22.48.666.666 0 0 0 .493.175h6.484a.666.666 0 0 0 .494-.174zm15.586-31.316c0 4.517-3.177 6.416-7.327 6.416h-8.04V25.233h8.04c4.215 0 7.327 2.03 7.327 6.547z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2BB7",
    d: "M119.825 16.656a.616.616 0 0 1 .175-.477.602.602 0 0 1 .473-.177h6.095a.602.602 0 0 1 .473.177c.124.126.188.3.175.477v19.641a10.49 10.49 0 0 1 9.143-4.365c6.937-.152 11.606 4.867 11.606 13.596v17.087a.613.613 0 0 1-.176.478.601.601 0 0 1-.473.177h-6.181a.602.602 0 0 1-.473-.177.616.616 0 0 1-.175-.478V46.903c0-5.172-2.529-7.594-6.095-7.594-4.993 0-7.068 4.582-7.262 8.969v14.337a.613.613 0 0 1-.176.478.601.601 0 0 1-.473.177h-6.008a.602.602 0 0 1-.473-.177.616.616 0 0 1-.175-.478V16.656z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2BB7",
    fillRule: "evenodd",
    d: "M179.996 32.5c-.39 0-.584.262-.714.655l-.972 3.644a11.355 11.355 0 0 0-9.618-4.823c-9.142 0-15.302 6.482-15.302 15.974 0 9.493 6.16 16.04 15.302 16.04a11.29 11.29 0 0 0 9.726-4.844l.907 3.47c.13.392.325.654.714.654h4.884a.652.652 0 0 0 .649-.654V33.155a.613.613 0 0 0-.176-.478.6.6 0 0 0-.473-.177h-4.927zm-4.714 21.668a8.192 8.192 0 0 1-6.244 2.425 8.065 8.065 0 0 1-6.127-2.426 8.228 8.228 0 0 1-2.324-6.216 8.098 8.098 0 0 1 2.269-6.278 7.933 7.933 0 0 1 6.182-2.386 8.145 8.145 0 0 1 6.2 2.358 8.312 8.312 0 0 1 2.445 6.218 8.36 8.36 0 0 1-2.401 6.305z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2BB7",
    d: "M193.287 63.27c-.583 0-.778-.458-.453-.916l12.967-22.914h-11.735a.601.601 0 0 1-.473-.178.613.613 0 0 1-.176-.477V33.22a.613.613 0 0 1 .176-.477.602.602 0 0 1 .473-.178h22.823c.519 0 .778.393.389 1.113L204.31 56.44h12.579c.164.005.32.078.43.202.11.123.165.286.154.452v5.565c0 .393-.195.655-.584.655l-23.602-.044z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2BB7",
    fillRule: "evenodd",
    d: "M245.03 54.563a10.25 10.25 0 0 1-6.938 2.422c-3.991.32-7.641-2.275-8.689-6.176h22.953a.581.581 0 0 0 .482-.168.595.595 0 0 0 .167-.486c.065-12.505-6.225-18.266-15.756-18.266a14.88 14.88 0 0 0-11.424 4.422 15.184 15.184 0 0 0-4.332 11.552c0 9.559 6.484 15.975 16.145 15.975a16.05 16.05 0 0 0 12.319-4.365.724.724 0 0 0 0-.982l-3.825-3.994a.581.581 0 0 0-.454-.196 1.03 1.03 0 0 0-.648.262zm-7.716-15.6c3.813 0 7.133 2.63 8.04 6.369h-16.08c.907-3.74 4.227-6.37 8.04-6.37z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2BB7",
    d: "M265 55.021v8.25h-8.364v-8.25H265zM54.008 21.527V57.32L65 80V0L54.008 21.527z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0093CC",
    d: "M47.405 0v80l-10.97-22.68V21.527L47.405 0z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#10D3F2",
    d: "M18.86 21.527V57.32L29.832 80V0l-10.97 21.527z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#91F8E9",
    d: "M0 21.527V57.32L10.97 80V0L0 21.527z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPositive);
export default __webpack_public_path__ + "static/media/logo-positive.07344f170bdac1da02b7b2c07c1788da.svg";
export { ForwardRef as ReactComponent };